// Weeks are Mon–Sun. Week 001 starts Jan 1 of the year (may be partial).
// Then W002 starts the following Monday. Last week is truncated at Dec 31.
export function computeWeeksOfYear(year) {
  const pad = (n) => String(n).padStart(2, "0");
  const iso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  const dec31 = new Date(year, 11, 31);
  const weeks = [];
  let cursor = new Date(year, 0, 1);
  let no = 1;
  while (cursor <= dec31) {
    const start = new Date(cursor);
    const dow = cursor.getDay(); // 0=Sun, 1=Mon, ..., 6=Sat
    const daysToSunday = dow === 0 ? 0 : (7 - dow);
    let end = new Date(cursor);
    end.setDate(cursor.getDate() + daysToSunday);
    if (end > dec31) end = new Date(dec31);
    weeks.push({
      no,
      label: `${year}-W${String(no).padStart(2, "0")}`,
      start: iso(start),
      end: iso(end),
    });
    cursor = new Date(end);
    cursor.setDate(end.getDate() + 1);
    no += 1;
  }
  return weeks;
}

export function fmtShortDate(iso) {
  if (!iso) return "";
  const [y, m, d] = iso.split("-");
  const monthsID = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agt", "Sep", "Okt", "Nov", "Des"];
  return `${parseInt(d, 10)} ${monthsID[parseInt(m, 10) - 1]} ${y}`;
}

export function projectLabel(p) {
  if (!p) return "-";
  // 149-cw-r187: pakai disambiguator dari backend saat nama duplikat supaya
  // dropdown & tabel tidak menyesatkan.
  const dis = p.disambiguator ? ` · ${p.disambiguator}` : "";
  if (p.project_type === "variation_order") return `${p.parent_project_name || p.project_name} · VO ${p.variation_order_name || ""}${dis}`.trim();
  if (p.project_type === "working_order") return `${p.parent_project_name || p.project_name} · WO ${p.wo_number || ""}${dis}`.trim();
  return `${p.project_name || "Untitled"}${dis}`;
}

/**
 * PROMPT 16-PETTY-CASH-OFFICE-COST-CENTER-R1: label untuk baris petty_cash
 * yang membedakan kantor (office) vs project. Untuk office, tampilkan nama
 * kantor dengan badge "Kantor". Untuk project, gunakan projectLabel lama.
 */
export function costCenterLabel(pc) {
  if (!pc) return "-";
  if (pc.cost_center_type === "office") {
    return pc.cost_center_name || pc.project_name || "Kantor";
  }
  if (pc.project_type === "variation_order") return `${pc.project_name} · VO ${pc.project_variation || ""}`.trim();
  if (pc.project_type === "working_order") return `${pc.project_name} · WO ${pc.project_wo_number || ""}`.trim();
  return pc.project_name || pc.cost_center_name || "Untitled";
}
